import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Heart } from "lucide-react";
import api from "@/lib/api";
import { ProductCard } from "@/components/ProductCard";
import { useAuth } from "@/context/AuthContext";
import { useWishlist } from "@/context/WishlistContext";

export default function WishlistPage() {
  const { user, loading } = useAuth();
  const { ids } = useWishlist();
  const [products, setProducts] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    if (!loading && !user) navigate("/login", { state: { from: "/wishlist" } });
    if (user) api.get("/wishlist").then(({ data }) => setProducts(data));
    document.title = "Wishlist — KKashigari India";
  }, [user, loading, ids.length]);

  if (loading || !user) return <div className="py-40 text-center uplabel text-[var(--olive)]">Loading…</div>;

  return (
    <div data-testid="wishlist-page" className="max-w-[1400px] mx-auto px-5 lg:px-10 py-12 lg:py-16">
      <div className="mb-10">
        <div className="uplabel mb-3">Saved For Later</div>
        <h1 className="font-serif text-4xl sm:text-5xl text-[var(--bronze)]">Your Wishlist</h1>
      </div>
      {products.length === 0 ? (
        <div className="py-24 text-center">
          <Heart className="w-12 h-12 text-[var(--olive)] mx-auto" strokeWidth={1} />
          <p className="font-serif text-2xl text-[var(--bronze)] mt-6">No favourites yet</p>
          <Link to="/shop" className="btn-primary inline-block px-8 py-4 uplabel mt-6">Explore Collection</Link>
        </div>
      ) : (
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 lg:gap-8">
          {products.map((p, i) => <ProductCard key={p.id} product={p} index={i} />)}
        </div>
      )}
    </div>
  );
}
